import * as css from './ExplainMap.css';
import FormikDropzon from '../../../../component/dropzone/FormikDropzone';
import Btn from '../../../../component/button/btn/Btn';
import {useTranslation} from 'react-i18next';
import {useField} from 'formik';
import {sendMap} from '../../../../redux/event/eventActions';
import {useSelector} from 'react-redux';
import TextareaInput from '../../../../component/input/textareaInput/TextareaInput';
import useStep from '../StepLeft/useStep';
import {useContext} from 'react';
import {newEventContext} from '../newEventForm/NewEventForm';
import {uploadFile} from '../../../../redux/user/userActions';
import {bounceMessage} from '../../../../layout/userMessages/UserMessage';

function ExplainMap({name,close,title, action}) {
    const {t} = useTranslation('newEvent');
    const eid = useSelector(s=>s.event.eid);
    const [{value}]=useField(name);
    const {steps,currentStep}=useContext(newEventContext);
    const {onContinue} = useStep(steps[currentStep]);
    const pid = useSelector(s=>s.account.pid);
    const sendMapXHR = useSelector(s=>s.event.sendMapXHR);

    const onClick = async() => {
        if(sendMapXHR==='LOADING') return;
        
        const imageLink = await uploadFile(value?.sendMap?.base64, '', 'uploadMap', eid);
        const message = t('sendMapMassage',{map:imageLink,eid:eid,text:value.message});
        await sendMap({message: action==='mapError' ? message + t('errorMap',{eid:value.eid}) : message,comment:t('comment',{comment:t(`${action}`)}), pid})
            .then(()=>{
                bounceMessage(t('successMessage') ,'attention');
                onContinue();
            });
    };
    const back = () => {
        close();
    };
    return (<>
        <css.back onClick={back}/>
        <css.wrap>
            <css.title>{title}</css.title> 
            <TextareaInput name={`${name}.message`}/>
        </css.wrap>
        <css.explainButtons $isUpload={value.sendMap}>
            <FormikDropzon name={`${name}.sendMap`} text={value?.sendMap?.name || t('uploadMap')} fileTypes={'image/jpeg, image/jpg, application/pdf'} />
            <Btn className={'white'} disabled={(value.message ==='' && !value.sendMap) || sendMapXHR==='LOADING'} onClick={onClick}>{t('send')}</Btn>
        </css.explainButtons>
    </>
    );
}

export default ExplainMap;
